const icons = {
    caret: caret,
    refresh: refresh,
    aqiLegend: aqiLegend,
    lineLegend: lineLegend,
    user: user,
    pencil: pencil,
    trash: trash,
    backArrow: backArrow,
    arsLogoText: arsLogoText,
    download: download,
    upload: upload,
    vDots: vDots,
    leftArrow: leftArrow,
    minimized: minimized,
    halfScreen: halfScreen,
    fullScreen: fullScreen
};

function caret(color, style = null) {
    return (
        <svg
            className="inline-svg"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.29289 8.79289C6.68342 8.40237 7.31658 8.40237 7.70711 8.79289L12 13.0858L16.2929 8.79289C16.6834 8.40237 17.3166 8.40237 17.7071 8.79289C18.0976 9.18342 18.0976 9.81658 17.7071 10.2071L12.7071 15.2071C12.3166 15.5976 11.6834 15.5976 11.2929 15.2071L6.29289 10.2071C5.90237 9.81658 5.90237 9.18342 6.29289 8.79289Z"
                fill={color}
            />
        </svg>
    );
}

function refresh(color, style = null) {
    return (
        <svg
            className="inline-svg"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                d="M4.06189 13C4.02104 12.6724 4 12.3387 4 12C4 7.58172 7.58172 4 12 4C14.5006 4 16.7332 5.14727 18.2002 6.94416M19.9381 11C19.979 11.3276 20 11.6613 20 12C20 16.4183 16.4183 20 12 20C9.61061 20 7.46589 18.9525 6 17.2916M9 17H6V17.2916M18.2002 4V6.94416M18.2002 6.94416V6.99993L15.2002 7M6 20V17.2916"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function aqiLegend(color1, color2, style = null) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <g>
                <rect
                    style={{
                        fill: color1,
                        strokeWidth: 2,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: 0,
                    }}
                    width="18"
                    height="20"
                    x="1"
                    y="20"
                />
                <rect
                    style={{
                        fill: color2,
                        strokeWidth: 2,
                        strokeLinecap: "square",
                        strokeLinejoin: "round",
                        strokeMiterlimit: 0,
                    }}
                    width="18"
                    height="39"
                    x="21"
                    y="1"
                />
            </g>
        </svg>
    );
}

function lineLegend(color, style = null) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <g>
                <path
                    style={{
                        fill: "none",
                        stroke: color,
                        strokeWidth: 2,
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeMiterlimit: 0,
                    }}
                    d="m 3.5650682,20 5.1361153,-3.564431 c 1.0082878,-0.699745 2.0458325,-1.386282 3.2093735,-1.776741 1.163542,-0.39046 2.433813,-0.47323 3.629007,-0.194305 1.195194,0.278926 2.292424,0.904529 3.222176,1.705684 0.929751,0.801155 1.700718,1.767613 2.446758,2.742145 1.507989,1.969845 3.006748,4.046255 5.136751,5.318027 1.684673,1.005877 3.704677,1.438669 5.653578,1.211297 1.948901,-0.227372 3.815025,-1.113546 5.222901,-2.48022"
                    id="path1"
                />
            </g>
        </svg>
    );
}

function user(color, style = null) {
    return (
        <svg
            viewBox="0 0 500 500"
            xmlns="http://www.w3.org/2000/svg"
            fill={color}
            style={style}
        >
            <path d="M 500 250 C 500 309.107 479.488 363.423 445.193 406.218 C 425.229 316.819 345.418 250 250 250 C 154.582 250 74.771 316.819 54.807 406.218 C 20.512 363.423 0 309.107 0 250 C 0 111.929 111.929 0 250 0 C 388.071 0 500 111.929 500 250 Z M 250 25 C 194.772 25 150 69.772 150 125 C 150 180.228 194.772 225 250 225 C 305.228 225 350 180.228 350 125 C 350 69.772 305.228 25 250 25 Z" />
        </svg>
    );
}

function pencil(color, style = null) {
    return (
        <svg
            fill={color}
            style={style}
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M4.07,14.927a.976.976,0,0,0-.167.25c-.011.023-.023.043-.032.067a.362.362,0,0,0-.019.04l-1.8,5.4A1,1,0,0,0,3,22a1.014,1.014,0,0,0,.316-.051l5.4-1.8c.013,0,.023-.013.036-.017s.041-.021.062-.031a.967.967,0,0,0,.259-.172c.01-.009.024-.012.033-.022l12.6-12.6a1,1,0,0,0,0-1.414l-3.6-3.6a1,1,0,0,0-1.414,0l-12.6,12.6C4.083,14.9,4.08,14.917,4.07,14.927ZM17.4,4.414,19.586,6.6,8.4,17.786,7.307,16.693,6.214,15.6ZM5.237,17.451l.656.656.656.656-1.968.656Z" />
        </svg>
    );
}

function trash(color, style = null) {
    return (
        <svg
            style={style}
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.82907 6.65808H18.6325V19.2906C18.6325 20.3951 17.7371 21.2906 16.6325 21.2906H7.82907C6.7245 21.2906 5.82907 20.3951 5.82907 19.2906V6.65808Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4 5.74365L20.4615 5.74365"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.9134 3H9.54816L8.57266 5.74359H15.8889L14.9134 3Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="12.3163"
                y1="10.4017"
                x2="12.3163"
                y2="17.547"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="9.57266"
                y1="10.4017"
                x2="9.57266"
                y2="17.547"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <line
                x1="15.0598"
                y1="10.4017"
                x2="15.0598"
                y2="17.547"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function backArrow(color, style = null) {
    return (
        <svg
            style={style}
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4 10L3.29289 10.7071L2.58579 10L3.29289 9.29289L4 10ZM21 18C21 18.5523 20.5523 19 20 19C19.4477 19 19 18.5523 19 18L21 18ZM8.29289 15.7071L3.29289 10.7071L4.70711 9.29289L9.70711 14.2929L8.29289 15.7071ZM3.29289 9.29289L8.29289 4.29289L9.70711 5.70711L4.70711 10.7071L3.29289 9.29289ZM4 9L14 9L14 11L4 11L4 9ZM21 16L21 18L19 18L19 16L21 16ZM14 9C17.866 9 21 12.134 21 16L19 16C19 13.2386 16.7614 11 14 11L14 9Z"
                fill={color}
            />
        </svg>
    );
}

function arsLogoText(color, style = null) {
    return (
        <svg
            viewBox="0 0 403.81522 91.333115"
            width="403.81522"
            height="91.333115"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <title id="title1">Air Resource Specialists</title>
            <path
                id="path2"
                style={{ fill: color }}
                d="m 63.999911,0 c -20.875798,0 -38,16.547395 -38,37 0,3.612548 0.544265,7.099228 1.539062,10.398438 l 6.509766,-8.783204 C 34.018507,38.080137 33.999911,37.542375 33.999911,37 c 0,-15.99808 13.320548,-29 30,-29 16.679452,0 30,13.00192 30,29 0,0.448833 -0.01441,0.893995 -0.03516,1.337891 l 6.556639,8.853515 C 101.47665,43.953147 101.99991,40.537288 101.99991,37 101.99991,16.547395 84.875709,0 63.999911,0 Z"
            />
            <path
                style={{
                    display: "inline",
                    fill: "none",
                    stroke: color,
                    strokeWidth: 8,
                    strokeLinecap: "butt",
                    strokeLinejoin: "miter",
                    strokeOpacity: 1,
                }}
                d="m 7.940419,87.28035 40.73239,-54.962412 6.594563,5.070348 8.849756,-16.802986 8.849755,16.810764 6.594564,-5.064553 40.732383,54.998209 -21.066269,-0.009 -70.220876,-0.0308 z"
                id="path15"
            />
            <path
                style={{
                    fill: "none",
                    stroke: color,
                    strokeWidth: 4,
                    strokeOpacity: 1,
                }}
                d="M 29.006685,87.2896 99.227561,87.32047 84.958943,60.18963 75.393084,78.149997 64.117128,44.206323 52.830483,78.160392 43.286001,60.171318 Z"
                id="path1"
            />
            <path
                d="m 131.85493,42.298691 13.52535,-29.866689 h 4.224 l 13.56801,29.866689 h -4.48 L 146.61761,14.821337 h 1.70667 L 136.2496,42.298691 Z m 5.76001,-7.466672 1.152,-3.413336 h 16.81068 l 1.23733,3.413336 z m 29.39737,7.466672 v -22.61335 h 4.096 v 22.61335 z m 2.048,-26.965354 q -1.19467,0 -2.00534,-0.768 -0.768,-0.768001 -0.768,-1.877335 0,-1.152001 0.768,-1.920001 Q 167.86564,10 169.06031,10 q 1.19467,0 1.96267,0.768001 0.81066,0.725334 0.81066,1.834668 0,1.152001 -0.768,1.962668 -0.768,0.768 -2.00533,0.768 z m 9.85598,26.965354 v -22.61335 h 3.92533 v 6.144004 l -0.384,-1.536001 q 0.93867,-2.346668 3.15734,-3.584003 2.21867,-1.237334 5.46134,-1.237334 v 3.968003 q -0.256,-0.04267 -0.51201,-0.04267 -0.21333,0 -0.42666,0 -3.28534,0 -5.20534,1.962669 -1.92,1.962668 -1.92,5.67467 v 11.264009 z m 29.56797,0 V 12.432002 h 11.64801 q 3.92534,0 6.69867,1.237334 2.77334,1.237334 4.26667,3.584003 1.49334,2.346668 1.49334,5.589337 0,3.242669 -1.49334,5.589338 -1.49333,2.304002 -4.26667,3.541336 -2.77333,1.237334 -6.69867,1.237334 h -9.30134 l 1.92,-1.962668 v 11.050675 z m 19.96802,0 -7.59468,-10.837342 h 4.56534 l 7.68001,10.837342 z m -15.70135,-10.624008 -1.92,-2.090668 h 9.17334 q 4.096,0 6.18667,-1.749335 2.13334,-1.792001 2.13334,-4.992004 0,-3.200002 -2.13334,-4.949337 -2.09067,-1.749334 -6.18667,-1.749334 h -9.17334 l 1.92,-2.133335 z m 36.224,10.880008 q -3.62667,0 -6.4,-1.493334 -2.73067,-1.493335 -4.26667,-4.096004 -1.49334,-2.602668 -1.49334,-5.973337 0,-3.370669 1.45067,-5.973338 1.49333,-2.602669 4.05334,-4.053336 2.60266,-1.493335 5.84533,-1.493335 3.28534,0 5.80267,1.450668 2.51734,1.450668 3.92534,4.096003 1.45067,2.602669 1.45067,6.101338 0,0.256 -0.0427,0.597334 0,0.341333 -0.0427,0.64 h -19.24268 v -2.944002 h 17.10935 l -1.664,1.024001 q 0.0427,-2.176002 -0.896,-3.88267 -0.93867,-1.706668 -2.60267,-2.645335 -1.62134,-0.981334 -3.79734,-0.981334 -2.13333,0 -3.79733,0.981334 -1.664,0.938667 -2.60267,2.688002 -0.93867,1.706668 -0.93867,3.925336 v 0.682667 q 0,2.261335 1.024,4.053337 1.06667,1.749334 2.944,2.730668 1.87734,0.981334 4.30934,0.981334 2.00534,0 3.62667,-0.682667 1.664,-0.682667 2.90134,-2.048001 l 2.26133,2.645335 q -1.536,1.792001 -3.84,2.730669 -2.26134,0.938667 -5.07734,0.938667 z m 22.528,0 q -2.816,0 -5.37601,-0.768001 -2.51733,-0.768 -3.968,-1.877334 l 1.70667,-3.242669 q 1.45067,0.981334 3.584,1.664001 2.13334,0.682667 4.352,0.682667 2.85867,0 4.09601,-0.810667 1.28,-0.810668 1.28,-2.261335 0,-1.066668 -0.768,-1.664002 -0.768,-0.597333 -2.048,-0.896 -1.23734,-0.298667 -2.77334,-0.512001 -1.536,-0.256 -3.072,-0.597333 -1.536,-0.384001 -2.816,-1.024001 -1.28,-0.682667 -2.04801,-1.834668 -0.768,-1.194668 -0.768,-3.157336 0,-2.048001 1.15201,-3.584002 1.152,-1.536002 3.24266,-2.346669 2.13334,-0.853334 5.03467,-0.853334 2.21867,0 4.48001,0.554667 2.304,0.512001 3.75467,1.493335 l -1.74934,3.242669 q -1.536,-1.024001 -3.2,-1.408001 -1.664,-0.384001 -3.328,-0.384001 -2.688,0 -4.01067,0.896001 -1.32267,0.853334 -1.32267,2.218668 0,1.152001 0.768,1.792002 0.81067,0.597333 2.048,0.938667 1.28,0.341334 2.816,0.597334 1.53601,0.213333 3.07201,0.597334 1.536,0.341333 2.77333,0.981334 1.28,0.64 2.048,1.792001 0.81067,1.152001 0.81067,3.072002 0,2.048002 -1.19467,3.541336 -1.19466,1.493335 -3.37067,2.346669 -2.176,0.810667 -5.20533,0.810667 z m 24.57599,0 q -3.41333,0 -6.05867,-1.493334 -2.64533,-1.493335 -4.18134,-4.096004 -1.536,-2.645335 -1.536,-5.973337 0,-3.370669 1.536,-5.973338 1.53601,-2.602669 4.18134,-4.053336 2.64534,-1.493335 6.05867,-1.493335 3.37067,0 6.01601,1.493335 2.688,1.450667 4.18133,4.053336 1.536,2.560002 1.536,5.973338 0,3.370669 -1.536,5.973337 -1.49333,2.602669 -4.18133,4.096004 -2.64534,1.493334 -6.01601,1.493334 z m 0,-3.584003 q 2.176,0 3.88267,-0.981334 1.74934,-0.981334 2.73067,-2.773335 0.98133,-1.834668 0.98133,-4.224003 0,-2.432002 -0.98133,-4.181337 -0.98133,-1.792001 -2.73067,-2.773335 -1.70667,-0.981334 -3.88267,-0.981334 -2.176,0 -3.88267,0.981334 -1.70667,0.981334 -2.73067,2.773335 -1.024,1.749335 -1.024,4.181337 0,2.389335 1.024,4.224003 1.024,1.792001 2.73067,2.773335 1.70667,0.981334 3.88267,0.981334 z m 26.9227,3.584003 q -2.90133,0 -5.12,-1.066667 -2.176,-1.066668 -3.41334,-3.24267 -1.19466,-2.218668 -1.19466,-5.54667 V 19.685341 h 4.096 V 32.22935 q 0,3.328002 1.57867,4.992004 1.62133,1.664001 4.52267,1.664001 2.13333,0 3.712,-0.853334 1.57867,-0.896001 2.432,-2.560002 0.85334,-1.706668 0.85334,-4.096003 V 19.685341 h 4.096 v 22.61335 h -3.88267 v -6.101338 l 0.64,1.621334 q -1.10933,2.261335 -3.328,3.49867 -2.21867,1.237334 -4.99201,1.237334 z m 19.37068,-0.256 v -22.61335 h 3.92533 v 6.144004 l -0.384,-1.536001 q 0.93867,-2.346668 3.15734,-3.584003 2.21867,-1.237334 5.46133,-1.237334 v 3.968003 q -0.256,-0.04267 -0.512,-0.04267 -0.21333,0 -0.42666,0 -3.28534,0 -5.20534,1.962669 -1.92,1.962668 -1.92,5.67467 v 11.264009 z m 26.8535,0.256 q -3.456,0 -6.18667,-1.493334 -2.688,-1.493335 -4.224,-4.096004 -1.53601,-2.602668 -1.53601,-5.973337 0,-3.370669 1.53601,-5.973338 1.536,-2.602669 4.224,-4.053336 2.73067,-1.493335 6.18667,-1.493335 3.072,0 5.46134,1.237334 2.432,1.194668 3.75467,3.584003 l -3.11467,2.005335 q -1.10934,-1.664001 -2.73067,-2.432002 -1.57867,-0.810667 -3.41334,-0.810667 -2.21866,0 -3.968,0.981334 -1.74933,0.981334 -2.77334,2.773335 -1.024,1.749335 -1.024,4.181337 0,2.432002 1.024,4.224003 1.02401,1.792001 2.77334,2.773335 1.74934,0.981334 3.968,0.981334 1.83467,0 3.41334,-0.768 1.62133,-0.810668 2.73067,-2.474669 l 3.11467,1.962668 q -1.32267,2.346669 -3.75467,3.62667 -2.38934,1.237334 -5.46134,1.237334 z m 24.22141,0 q -3.62667,0 -6.40001,-1.493334 -2.73067,-1.493335 -4.26667,-4.096004 -1.49333,-2.602668 -1.49333,-5.973337 0,-3.370669 1.45066,-5.973338 1.49334,-2.602669 4.05334,-4.053336 2.60267,-1.493335 5.84534,-1.493335 3.28533,0 5.80267,1.450668 2.51733,1.450668 3.92534,4.096003 1.45066,2.602669 1.45066,6.101338 0,0.256 -0.0427,0.597334 0,0.341333 -0.0427,0.64 h -19.24268 v -2.944002 h 17.10934 l -1.664,1.024001 q 0.0427,-2.176002 -0.896,-3.88267 -0.93866,-1.706668 -2.60267,-2.645335 -1.62133,-0.981334 -3.79733,-0.981334 -2.13334,0 -3.79734,0.981334 -1.664,0.938667 -2.60267,2.688002 -0.93866,1.706668 -0.93866,3.925336 v 0.682667 q 0,2.261335 1.024,4.053337 1.06666,1.749334 2.944,2.730668 1.87733,0.981334 4.30934,0.981334 2.00533,0 3.62666,-0.682667 1.66401,-0.682667 2.90134,-2.048001 l 2.26134,2.645335 q -1.53601,1.792001 -3.84001,2.730669 -2.26133,0.938667 -5.07733,0.938667 z"
                id="text1"
                style={{
                    fill: color,
                    stroke: "none",
                    fontWeight: 500,
                    fontSize: "42.6667px",
                    fontFamily: "Montserrat",
                }}
                aria-label="Air Resource"
            />
            <path
                d="m 148.79641,82.293358 q -3.328,0 -6.31467,-1.109334 -2.944,-1.152001 -4.56533,-2.944002 l 0.98133,-1.621335 q 1.536,1.578668 4.18134,2.688002 2.688,1.066668 5.67467,1.066668 2.98667,0 4.864,-0.768001 1.92,-0.810667 2.816,-2.133335 0.93867,-1.322667 0.93867,-2.944002 0,-1.920001 -1.024,-3.072002 -1.024,-1.152001 -2.688,-1.834668 -1.664,-0.682667 -3.62667,-1.152001 -1.96267,-0.469334 -3.96801,-0.981334 -2.00533,-0.554667 -3.66933,-1.408001 -1.664,-0.853334 -2.688,-2.304002 -0.98134,-1.493334 -0.98134,-3.840003 0,-2.133335 1.10934,-3.925336 1.10933,-1.792001 3.456,-2.901336 2.34667,-1.109334 6.016,-1.109334 2.47467,0 4.86401,0.725334 2.432,0.725334 4.13867,1.962668 l -0.81067,1.749335 q -1.87733,-1.280001 -4.05334,-1.877335 -2.13333,-0.64 -4.13867,-0.64 -2.85866,0 -4.736,0.810667 -1.87733,0.810667 -2.77334,2.176002 -0.896,1.322667 -0.896,2.986669 0,1.920001 0.98134,3.072002 1.024,1.152001 2.688,1.834668 1.664,0.682667 3.66934,1.152001 2.00533,0.469333 3.968,1.024 1.96267,0.512001 3.62667,1.365335 1.664,0.853334 2.688,2.304002 1.024,1.450667 1.024,3.754669 0,2.090668 -1.152,3.925336 -1.152,1.792002 -3.54134,2.901336 -2.34666,1.066667 -6.05867,1.066667 z m 18.13332,-0.213333 V 52.213336 h 10.70934 q 3.75467,0 6.44267,1.194667 2.688,1.194668 4.13867,3.456003 1.45067,2.218668 1.45067,5.418671 0,3.114669 -1.45067,5.376004 -1.45067,2.261335 -4.13867,3.456002 -2.688,1.194668 -6.44267,1.194668 h -9.51467 l 0.98133,-1.024001 v 10.794675 z m 2.176,-10.666675 -0.98133,-1.066667 h 9.51467 q 4.82134,0 7.29601,-2.090669 2.51733,-2.133335 2.51733,-5.973337 0,-3.88267 -2.51733,-5.973338 -2.47467,-2.133335 -7.29601,-2.133335 h -9.51467 l 0.98133,-1.066668 z m 29.82402,-5.461337 h 16.17068 v 1.920001 h -16.17068 z m 0.256,14.165344 h 18.43201 v 1.962668 H 197.00975 V 52.213336 h 19.96801 v 1.962668 h -17.79201 z m 38.85522,2.176001 q -3.32801,0 -6.18668,-1.109334 -2.816,-1.152001 -4.90667,-3.200002 -2.09066,-2.048002 -3.24267,-4.778671 -1.152,-2.773335 -1.152,-6.058671 0,-3.285336 1.152,-6.016004 1.15201,-2.773336 3.24267,-4.821337 2.13334,-2.048002 4.94934,-3.157336 2.816,-1.152001 6.14401,-1.152001 3.15733,0 5.888,1.024001 2.77333,1.024001 4.736,3.114669 l -1.36533,1.408001 q -1.92,-1.877335 -4.26667,-2.688002 -2.304,-0.853334 -4.90667,-0.853334 -2.85867,0 -5.33334,0.981334 -2.432,0.981334 -4.26667,2.773336 -1.792,1.792001 -2.816,4.181336 -0.98133,2.389335 -0.98133,5.205337 0,2.816002 0.98133,5.205337 1.024,2.389336 2.816,4.181337 1.83467,1.792001 4.26667,2.773335 2.47467,0.981334 5.33334,0.981334 2.60267,0 4.90667,-0.810667 2.34667,-0.853334 4.26667,-2.773335 l 1.36533,1.408001 q -1.96267,2.090668 -4.736,3.157335 -2.73067,1.024001 -5.888,1.024001 z m 17.91999,-0.213333 V 52.213336 h 2.176 v 29.866689 z m 7.59468,0 13.73867,-29.866689 h 2.176 l 13.73868,29.866689 h -2.34667 L 277.89165,53.57867 h 0.93866 L 265.9023,82.080025 Z m 5.03467,-8.40534 0.72533,-1.834668 h 17.87735 l 0.72533,1.834668 z m 30.03735,8.40534 V 52.213336 h 2.176 v 27.904021 h 17.19468 v 1.962668 z m 24.95999,0 V 52.213336 h 2.176 v 29.866689 z m 20.43734,0.213333 q -3.328,0 -6.31467,-1.109334 -2.944,-1.152001 -4.56534,-2.944002 l 0.98134,-1.621335 q 1.536,1.578668 4.18133,2.688002 2.688,1.066668 5.67467,1.066668 2.98667,0 4.86401,-0.768001 1.92,-0.810667 2.816,-2.133335 0.93867,-1.322667 0.93867,-2.944002 0,-1.920001 -1.024,-3.072002 -1.024,-1.152001 -2.68801,-1.834668 -1.664,-0.682667 -3.62667,-1.152001 -1.96266,-0.469334 -3.968,-0.981334 -2.00533,-0.554667 -3.66933,-1.408001 -1.66401,-0.853334 -2.68801,-2.304002 -0.98133,-1.493334 -0.98133,-3.840003 0,-2.133335 1.10933,-3.925336 1.10934,-1.792001 3.45601,-2.901336 2.34666,-1.109334 6.016,-1.109334 2.47467,0 4.864,0.725334 2.43201,0.725334 4.13867,1.962668 l -0.81066,1.749335 q -1.87734,-1.280001 -4.05334,-1.877335 -2.13333,-0.64 -4.13867,-0.64 -2.85867,0 -4.736,0.810667 -1.87734,0.810667 -2.77334,2.176002 -0.896,1.322667 -0.896,2.986669 0,1.920001 0.98134,3.072002 1.024,1.152001 2.688,1.834668 1.664,0.682667 3.66933,1.152001 2.00534,0.469333 3.96801,1.024 1.96266,0.512001 3.62667,1.365335 1.664,0.853334 2.688,2.304002 1.024,1.450667 1.024,3.754669 0,2.090668 -1.152,3.925336 -1.152,1.792002 -3.54134,2.901336 -2.34667,1.066667 -6.05867,1.066667 z m 23.42398,-0.213333 V 54.176004 h -10.75201 v -1.962668 h 23.68002 v 1.962668 h -10.75201 v 27.904021 z m 25.61423,0.213333 q -3.328,0 -6.31467,-1.109334 -2.94401,-1.152001 -4.56534,-2.944002 l 0.98133,-1.621335 q 1.53601,1.578668 4.18134,2.688002 2.688,1.066668 5.67467,1.066668 2.98667,0 4.86401,-0.768001 1.92,-0.810667 2.816,-2.133335 0.93866,-1.322667 0.93866,-2.944002 0,-1.920001 -1.024,-3.072002 -1.024,-1.152001 -2.688,-1.834668 -1.664,-0.682667 -3.62667,-1.152001 -1.96267,-0.469334 -3.968,-0.981334 -2.00534,-0.554667 -3.66934,-1.408001 -1.664,-0.853334 -2.688,-2.304002 -0.98133,-1.493334 -0.98133,-3.840003 0,-2.133335 1.10933,-3.925336 1.10934,-1.792001 3.456,-2.901336 2.34667,-1.109334 6.01601,-1.109334 2.47467,0 4.864,0.725334 2.432,0.725334 4.13867,1.962668 l -0.81067,1.749335 q -1.87733,-1.280001 -4.05333,-1.877335 -2.13334,-0.64 -4.13867,-0.64 -2.85867,0 -4.736,0.810667 -1.87734,0.810667 -2.77334,2.176002 -0.896,1.322667 -0.896,2.986669 0,1.920001 0.98133,3.072002 1.024,1.152001 2.68801,1.834668 1.664,0.682667 3.66933,1.152001 2.00534,0.469333 3.968,1.024 1.96267,0.512001 3.62667,1.365335 1.664,0.853334 2.68801,2.304002 1.024,1.450667 1.024,3.754669 0,2.090668 -1.152,3.925336 -1.15201,1.792002 -3.54134,2.901336 -2.34667,1.066667 -6.05867,1.066667 z"
                id="text2"
                style={{
                    fill: color,
                    stroke: "none",
                    fontWeight: 300,
                    fontSize: "42.6667px",
                    fontFamily: "Montserrat",
                }}
                aria-label="SPECIALISTS"
            />
        </svg>
    );
}

function download(color, style = null) {
    return (
        <svg
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            fill="none"
            style={style}
        >
            <path
                id="Vector"
                d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function upload(color, style = null) {
    return (
        <svg
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                d="M12.5 17L12.5 4M12.5 4L18 8.78947M12.5 4L7 8.78947"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6 21H19"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function vDots(color, style = null) {
    return (
        <svg
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                d="M12 12H12.01M12 6H12.01M12 18H12.01M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18ZM13 6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function leftArrow(color, style = null) {
    return (
        <svg
            width="800px"
            height="800px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7071 4.29289C12.0976 4.68342 12.0976 5.31658 11.7071 5.70711L6.41421 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H6.41421L11.7071 18.2929C12.0976 18.6834 12.0976 19.3166 11.7071 19.7071C11.3166 20.0976 10.6834 20.0976 10.2929 19.7071L3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12C3 11.7348 3.10536 11.4804 3.29289 11.2929L10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289Z"
                fill={color}
            />
        </svg>
    );
}

function minimized(color, style = null) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <rect fill={color} width="40" height="5" x="0" y="35" />
        </svg>
    );
}

function halfScreen(color, style = null) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path
                fill={color}
                d="m 0,20 v 5 15 h 5 30 5 V 35 25 20 h -5 z m 5,5 H 35 V 35 H 5 Z"
            />
        </svg>
    );
}

function fullScreen(color, style = null) {
    return (
        <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
        >
            <path fill={color} d="m 0,0 v 5 5 H 5 V 5 h 5 V 0 H 5 Z" />
            <path
                fill={color}
                d="M 0,40 H 5 9.9999999 V 35 H 5 V 30 H 0 v 5 z"
            />
            <path fill={color} d="m 40,40 v -5 -5 h -5 v 5 h -5 v 5 h 5 z" />
            <path fill={color} d="m 40,0 h -5 -5 v 5 h 5 v 5 h 5 V 5 Z" />
        </svg>
    );
}

export default icons;
